module.exports = __webpack_public_path__ + "static/media/nft-30.fecd7582.jpg";